import { FunctionComponent } from "react";
import ClientNotes from "src/components/dashboard/clients/ClientNotes";
import { LoadingSpinner, PageContainer, PageTitle } from "src/components/generic";
import { useAuth } from "src/context/AuthContext"
import { userTypes } from "src/utils/types";


const ProfileNotes: FunctionComponent = () => {
    const { user } = useAuth();

    if (!user) return <LoadingSpinner />
    if(user.userType !== userTypes.AccountTypes.CLIENT) return <p>Invalid Access</p>
    return (
        <PageContainer>
            <PageTitle title="Notes" />

            <ClientNotes client={user} />
        </PageContainer>
    )
}

export default ProfileNotes;